import React from 'react'
import { Helmet } from 'react-helmet'
import SecondaryHeader from '../masterLayout/SecondaryHeader'
import { Link } from 'react-router-dom'
const HealthPlans = () => {
 return (
  <React.Fragment>
   <Helmet>
    <title>Health Plans</title>
   </Helmet>
   <SecondaryHeader
    page_title="Health Plans"
    banner={require('../assets/images/health-plans/banner.jpg')}
   />
   <div className="sectionWrap">
    <div className="sectionContainer">
     <div className="health-plans-page">
      <section className="intro-copy">
       <h4 className="lead">Modernize Your Health Plan</h4>
       <h4 className="lead">with Medical Cannabis Coverage</h4>
       <p>
        Medical cannabis is safe, effective, and life–changing for millions
        managing conditions like chronic pain, anxiety, PTSD, cancer–related
        symptoms, and more. Yet, patients who choose this natural alternative
        treatment are forced to pay out of pocket because coverage isn’t
        included in most health plans.
       </p>
       <p>
        When medical cannabis is provided as a covered benefit, patients gain
        real, affordable choice in how they manage their health. The result?
       </p>
       <ul className="bullets">
        <li>
         <strong>More patients transition off high–risk pharmaceuticals</strong>{' '}
         and find relief with fewer side effects.
        </li>
        <li>
         <strong>Access improves</strong>, so individuals are more likely to
         begin and stick with treatment.
        </li>
        <li>
         <strong>Health plans deliver personalized, lower–risk care</strong>{' '}
         that aligns with modern wellness strategies.
        </li>
        <li>
         <strong>Health outcomes improve</strong> and overall costs become more
         manageable.
        </li>
       </ul>
      </section>

      <section className="bp-highlight wellness-card">
       <div className="two-col">
        <div className="col media">
         <img
          src={require('../assets/images/health-plans/shutterstock_532367098.jpg')}
          alt="Employee wellness program"
         />
        </div>
        <div className="col text">
         <h5>A Smarter, More Equitable Benefit</h5>
         <p>Your members want choice.</p>
         <p>Your plan wants outcomes.</p>
         <p>Medical cannabis can support both.</p>
        </div>
       </div>
      </section>

      <section className="section-copy">
       <h5>
        By recognizing medical cannabis as a valid treatment option, your plan
        can:
       </h5>
       <ul className="bullets">
        <li>Reduce reliance on opioids and polypharmacy</li>
        <li>Improve quality of life for members with chronic conditions</li>
        <li>Lead the way in wellness–forward, patient–centered care</li>
       </ul>
      </section>

      <section className="section-copy">
       <h5>
        Bennabix is the expert in understanding and working with all health plan
        structures:
       </h5>
       <p>
        Our executive leadership has more than 120 years’ combined health plan
        experience. Our program is available to self–funded group health plans,
        TPAs, and PBMs. Our health plan model is easily integrated into existing
        employee benefit plans. Bennabix manages the transactions and provides
        payers with a layer of protection from uncertain federal risk.
       </p>
      </section>

      <section className="conditions-band">
       <h5>Conditions Benefitting from Medical Cannabis:</h5>
       <p>
        Overall, there are 50+ medical conditions for which medical cannabis can
        be recommended (varying by state). Medical cannabis is most often used
        to manage chronic pain from MS, ALS, cancer and more. It is used for
        neuropathic and spinal pain. Patients with glaucoma, Crohn’s disease and
        endometriosis have successfully used medical cannabis. There are
        suggestions that cannabis can ease withdrawal from substance use
        disorder as well.
       </p>
      </section>

      <h3 className="closing-heading">
       Health plans are exploring cannabis–inclusive models.<br />Will yours be next?
      </h3>
      <section className="two-col closing">
       <div className="col text">
        <ul className="bullets">
         <li>Enhance benefit design</li>
         <li>Meet growing demand</li>
         <li>Drive better health outcomes</li>
        </ul>
       </div>
       <div className="col media">
        <img
         src={require('../assets/images/health-plans/dr-cannabis.jpg')}
         alt="Clinician holding cannabis"
        />
       </div>
      </section>
      <section className="footer-cta">
        <h5>Let's Talk</h5>
        <p>
         Bring medical cannabis coverage into the conversation.
        </p>
        <p>
         Email us at team@bennabix.com or <Link to="/contact">Contact us</Link> to learn how you can implement Bennabix.
        </p>
       </section>
     </div>
    </div>
   </div>
  </React.Fragment>
 )
}
export default HealthPlans
